import { Controller } from "@hotwired/stimulus";

// Waits `wait` ms after the last input before submitting the enclosing
// form — the History search field debounces so each keystroke doesn't
// fire a full-page GET.
export default class extends Controller {
  static values = { wait: { type: Number, default: 350 } };

  submit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.element.closest("form").requestSubmit(), this.waitValue);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
